import {
  Dropzone as MantineDropzone,
  DropzoneProps as MantineDropzoneProps,
} from '@mantine/dropzone';
import { forwardRef } from 'react';

import { ZorroLoaderV2 } from '../Loader/Loader';
import styles from './Dropzone.module.css';
import { EmptyDropzone } from './EmptyDropzone';

export type DropzoneProps = Omit<
  MantineDropzoneProps,
  'styles' | 'classNames' | 'style'
>;

export const Dropzone = Object.assign(
  forwardRef<HTMLDivElement, DropzoneProps>(
    ({ className, loading, ...props }, ref) => {
      const rootClassName = [styles.root, className].filter(Boolean).join(' ');

      return (
        <div className={styles.wrapper}>
          <MantineDropzone
            ref={ref}
            unstyled
            loading={loading}
            classNames={{
              root: rootClassName,
              inner: styles.inner,
            }}
            {...props}
          />
          {loading && (
            <div className={styles.loadingOverlay}>
              <ZorroLoaderV2 />
            </div>
          )}
        </div>
      );
    }
  ),
  {
    displayName: 'Dropzone',
    Accept: MantineDropzone.Accept,
    Reject: MantineDropzone.Reject,
    Idle: MantineDropzone.Idle,
    Empty: EmptyDropzone,
  }
);
